<template>
  <div class="share_pop">
    <van-popup class="uni_pop" v-model="popupVisible" position="bottom" :close-on-click-overlay="true" :safe-area-inset-bottom="true">
      <div class="box">
        <div class="share">
          <div class="shareline"></div>
          <div class="share_title">分享至</div>
          <div class="share_price">
            <div class="share_list">
              <div class="share_item" v-for="(item, index) in shareList" :key="index" @click='select(item.type)' v-if="!isPointsPage || isPointsPage">
                <div class="share_ico">
                  <img :src="item.ico">
                </div>
                <div class="share_size">{{ item.text }}</div>
              </div>
              <div class="jubao share_item" v-if="shareData.isTopic && !shareData.isJb && shareData.customer_id != (userInfo && userInfo.customer_id)" @click="jubaoTopic">
                <div class="share_ico">
                  <img src="@/assets/image/shequ/ts.png">
                </div>
                <div class="share_size">举报</div>
              </div>
              <div class="delete share_item" v-else-if="shareData.isTopic && !shareData.isJb" @click="deleteTopic">
                <div class="share_ico">
                  <img src="@/assets/image/shequ/sc.png">
                </div>
                <div class="share_size">删除</div>
              </div>
            </div>
            <!-- <div v-if="shareData.isTopic" class="topic_line"></div>
            <div class="share_list topic_box" v-if="shareData.isTopic && !shareData.isJb">
              <div class="jubao share_item" v-if="shareData.customer_id != (userInfo && userInfo.customer_id)" @click="jubaoTopic">
                <img src="@/assets/image/shequ/ts.png" style="object-fit: fill" />
                <span class="share_size">举报</span>
              </div>
              <div class="delete share_item" v-else @click="deleteTopic">
                <img src="@/assets/image/shequ/sc.png" style="object-fit: fill" />
                <span class="share_size">删除</span>
              </div>
            </div> -->
          </div>
          <div class="tips" v-if="isApp && !isIos">温馨提示：每日微信\QQ分享受限时，可选择复制链接方式代替</div>
        </div>
      </div>
    </van-popup>
    <div class="popup1">
      <remind-popup @onSuccess="onSuccess" @onClose="onClose" ref="remindPopup" title="温馨提示" text="确认删除该帖子吗？" closeText="确认" onText="取消"></remind-popup>
    </div>
  </div>
</template>

<script>
import { shareArticle, shareGame } from '@/api/community.js'
import { mapGetters, mapState } from 'vuex'
import store from '@/store'
import router from '@/router'

const APP_SHARE_LIST = [{
  ico: require("@/assets/image/share/wx.png"),
  text: "微信",
  type: 1
},
{
  ico: require("@/assets/image/share/pyq.png"),
  text: "微信朋友圈",
  type: 2
},
{
  ico: require("@/assets/image/share/qq.png"),
  text: "QQ",
  type: 3
},
{
  ico: require("@/assets/image/share/kj.png"),
  text: "QQ 空间",
  type: 4
},
]

export default {
  props: {
    id: {
      type: String,
      default: '0'
    },
    isPointsPage: {
      type: Boolean,
      default: false
    },
    shareData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      popupVisible: false,
      loading: false,
      shareList: [{
        ico: require("@/assets/image/share/lj.png"),
        text: "复制链接",
        type: 5
      }],
      copyUrl: "",

      share_url: '',
      share_title: '',
      share_desc: '',
      share_img: '',
    }
  },
  computed: {
    ...mapGetters(['logged']),
    userInfo() {
      return store?.state?.user?.info || null
    },
    isApp() {
      return this.$isApp()
    },
    isIos() {
      return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$isApp() && !this.isIos) {
        this.shareList = [...APP_SHARE_LIST, ...this.shareList]
      }
    }, 500)
  },
  methods: {
    select(type) {
      console.log(type, 'type');
      this.getinvitationShare(type)
    },
    report() {
      this.close()
      this.$emit("report")
    },
    copy() {
      let that = this
      console.log(that.copyUrl, 'that.copyUrl');
      this.$copyText(that.copyUrl).then(() => {
        that.$toast("复制成功，快去分享给好友吧！")
        that.popupVisible = false
      }, () => {
        that.$toast("复制失败")
      })
    },
    //分享朋友圈 微信好友参数
    setShareQuery(data) {
      this.share_title = data.share_title
      this.share_url = data.share_url
      this.share_desc = data.share_desc
      this.share_img = data.share_img
    },

    // 获取分享链接
    async getinvitationShare(share_type) {
      if (share_type == 2) {
        this.loading = true
      }

      if (share_type == 5 && this.isIos) {
        this.copyUrl = location.href
        this.copy()
      }

      let code, data, msg;

      switch (this.shareData.isGame) {
        case true:
          //分享游戏
          ({ code, data, msg } = await shareGame({
            game_id: this.shareData.id,
            share_type: share_type
          }))
          break;
        case undefined:
          //分享帖子
          ({ code, data, msg } = await shareArticle({
            article_id: this.shareData.id,
            share_type: share_type,
            scene: this.shareData.scene,
            game_id: this.shareData.game_id
          }))
          break;
        case 'sign':
          // 分享限时签到
          ({ code, data, msg } = await this.$ajax('/limitedSignin/shareLimitedSignin', { share_type, limited_id: this.shareData.limited_id }))
          break;
        case 'lottery':
          // 分享抽奖活动
          ({ code, data, msg } = await this.$ajax('/lottery/lotteryShare', { share_type, lottery_id: this.shareData.lottery_id }))
          break;
        case 'template':
          // 分享模板
          ({ code, data, msg } = await this.$ajax('/GeneralActivity/share', { share_type, activity_id: this.shareData.activity_id, share_link: this.shareData.share_link || ''}))
          break;
      }

      if (code == 200) {
        this.$emit('shareSuccess')
        if (share_type === 5) {
          // 复制链接
          console.log(data, "复制");
          this.copyUrl = data.content || data.share_url
          this.copy()
          return;
        }

        this.setShareQuery(data)

        // Post Message for Share
        this.postShareMessage(share_type, data)

        if (this.shareData.shareSuccess) {
          this.shareData.shareSuccess()
        }
      } else {
        this.$toast(msg);
      }
    },

    postShareMessage(type, data) {
      uni.postMessage({
        data: {
          action: 'share',
          params: {
            provider: type,
            href: this.share_url,
            title: this.share_title,
            summary: this.share_desc,
            imageUrl: this.share_img
          }
        }
      });
    },

    open() {
      this.popupVisible = true
    },
    close() {
      this.popupVisible = false
    },
    onSuccess() {
      this.$refs.remindPopup.close()
    },
    onClose() {
      this.$refs.remindPopup.close()
      this.$ajax('/article/deleteArticle', {
        id: this.shareData.id
      }).then(rs => {
        if (rs.code == 200) {
          this.$toast(rs.msg)
          this.shareData.deleteTopic()
          this.popupVisible = false
        } else {
          this.$toast(rs.msg)
        }
      })
    },
    // 删除帖子
    deleteTopic() {
      this.$refs.remindPopup.open()
    },
    jubaoTopic() {
      if (!this.$isLogin()) {
        this.$toast('请先登录');
        this.popupVisible = false
        return
      }
      this.popupVisible = false
      router.push({
        path: '/pages/complaint/complaint',
        query: {
          type: 1,
          target_id: this.shareData.id
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
  .share {
    background: #ffffff;
    border-radius: 0.5rem 0.5rem 0 0;
    position: relative;
    padding: 0.3rem 0 1.3rem;

    .tips {
      color: #666;
      font-size: 0.6rem;
      text-align: center;
      margin: 1rem 0;
      position: relative;

      &::before {
        content: "";
        height: 1px;
        background: #f8f8f8;
        position: absolute;
        width: calc(100% - 2rem);
        top: -1rem;
      }
    }

    .shareline {
      width: 1.5rem;
      height: 0.2rem;
      background: #cacaca;
      border-radius: 0.8rem;
      margin: 0 auto;
    }

    .share_title {
      font-size: 0.7rem;
      color: #8e8e8e;
      text-align: center;
      padding-top: 0.5rem;
    }

    .share_price {
      padding: 1rem 0.25rem 0rem;
      box-sizing: border-box;

      .share_list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .share_item {
          flex: 0 0 calc(100% / 5);
          display: flex;
          align-items: center;
          flex-direction: column;
          padding-bottom: 0.65rem;

          /* 分隔线 */
          .share_ico {
            width: 2.25rem;
            height: 2.3rem;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .share_size {
            padding-top: 0.35rem;
            color: #1d1d1d;
            font-size: 0.6rem;
          }
        }

        .share_item:nth-child(6) {
          border-bottom: none;
          padding-bottom: 0rem;
        }

        .share_item:nth-child(7) {
          border-bottom: none;
          padding-bottom: 0rem;
        }
      }

      .share_list > div {
        width: calc(20% - 0.05rem);
        margin-bottom: 0.25rem;
      }
    }

    .rail {
      height: 0.55rem;
      background: #f9f6f0;
    }

    .cancel {
      text-align: center;
      font-size: 0.7rem;
      padding-top: 0.9rem;
      padding-bottom: 2.4rem;
    }
  }
}

.uni_pop {
  z-index: 2000 !important;
}

.share_pop {
  ::v-deep .van-overlay {
    z-index: 1999 !important;
  }

  .popup1 {
    ::v-deep .van-overlay {
      z-index: 2001 !important;
    }
  }
}

.topic_line {
  height: 0.05rem;
  background: #f8f8f8;
  margin: 0 1.05rem;
  margin-bottom: 1.05rem;
}

.topic_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .jubao,
  .delete {
    text-align: center;
    padding-bottom: 0 !important;

    img {
      width: 2.25rem;
      height: 2.25rem;
      display: block;
    }
  }
}
</style>
